export const DEFAULT_NS = 'translation';
export const DEFAULT_LNG = 'en';
